import { render } from "./paying-partner-badge.vue?vue&type=template&id=428e82b8"
import script from "./paying-partner-badge.vue?vue&type=script&lang=js"
export * from "./paying-partner-badge.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__